<template>
    <div class="con">
		<div class="des">
			<p>In order for you to borrow the loan smoothly, please be sure to fill in the correct personal information, contact information and job information. </p>
			<br>
			<p>We will never disclose your information and will not use it for other purposes.</p>
		</div>
		<ul>
			<li v-for="(item,index) in list" :key="index" @click="toDetail(item)">
				<div>
					<img :src="item.img">
					<span>{{item.label}}</span>
				</div>
			   <div class="check" :class="{'checked':userInfo.status > index+1}"></div>
			</li>
		</ul>
		<div class="next" @click="next">Next</div>
    </div>
</template>

<script>
export default{
    data(){
        return {
			iShowExtend:false,
			linkStatus:{
				1:"./personal.html",
				2:"./contact.html",
				3:"./work.html",
				4:"./idCard.html",
				5:"./loan.html",
				6:"./loan.html"
			},
			list:[
				{label:'Personal Information',img:require("./img/personal.png"),path:'./personal.html',code:1},
				{label:'Contact Information',img:require("./img/contact.png"),path:'./contact.html',code:2},
				{label:'Work Information',img:require("./img/work.png"),path:'./work.html',code:3},
				{label:'Valid ID Photo',img:require("./img/valid.png"),path:'./idCard.html',code:4}
			]
        }
    },
	props:{
		userInfo:{
			type:Object,
			default:()=>{}
		},
		productType:{
			type:String,
			default:""
		}
	},

    methods:{
		toDetail(item){
			if(item.code == "1"){//查看个人信息
				location.href = item.path+"?productType="+this.productType
			}
			if(item.code == "2"){//查看联系人
				if(this.userInfo.status == "1"){
					this.UTILS.logStr("please fill previous information first");
					return
				}
				location.href = item.path+"?productType="+this.productType
			}
			if(item.code == "3"){//查看工作信息
				if(this.userInfo.status < 3){
					this.UTILS.logStr("please fill previous information first");
					return
				}
				location.href = item.path+"?productType="+this.productType
			}
			if(item.code == "4"){//查看身份资料
				if(this.userInfo.status < 4){
					this.UTILS.logStr("please fill previous information first");
					return
				}
				location.href = item.path+"?productType="+this.productType
			}
		},
		next(){
			// 1.完成注册,2.完成个人信息,3.完成联系人,4完成工作,5完成影像
			location.href = this.linkStatus[this.userInfo.status]+"?productType="+this.productType;
		}
    }
}
</script>

<style scoped>
.con{margin-bottom: 0.3rem;}
.con .des{padding: 0.3rem; background: #ED7D31 }
.con .des p{color: #fff;font-size: 0.26rem;line-height: 0.36rem;}
.con li{padding: 0.3rem;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid #ccc;}
.con li img{width: 0.6rem;height: 0.6rem;margin-right: 0.3rem;}
.con li span{font-size: 0.3rem;}
.con li .check{width: 0.5rem;height: 0.5rem;border: 1px solid #3c5bdb;border-radius: 50%;}
.con li .checked{background:url(./img/checked.png) no-repeat center;background-size:100% 100%;}
.con .next{width: 80%; margin: 1.6rem auto 0; text-align: center; padding: 0.3rem 0; font-size: .3rem; font-weight: 700; color: #fff; line-height: 1.6; background-color: #ED7D31; border-radius: 0.16rem;}
</style>
